import { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { ModalStatusServer } from '../../../../../components/Modals/ModalStatusServer'
import { isStatusSucess } from '../../../../../helpers/helpers'
import { useForm } from '../../../../../hooks/useForm'
import { useValidator } from '../../../../../hooks/useValidator'
import { useLang } from '../../../../../language'
import { InscripcionServices } from '../../../../inscripciones/admin/pages/Inscripciones/Inscripcion/controllers/services/inscripciones.service'
import { WizardNuevoAlquiler } from './Alquiler/WizardNuevoAlquiler'

export const ModalAlquiler = ({ showModal_Alquiler, handleCloseModal_Alquiler, fetchAlquileresGET, formValuesSearch,
    fetchPersonaDatosEconomicosGET, urlParams, idevento, isGratuito, fetchPersonaEntidadPOST,
    fetchPersonaEntidadPOSTData }: any) => {

    // -------- variables 

    const Lang = useLang()

    // -------- Formulario principal

    const [formInscripcion, handleInputInscripcion, handleFormInscripcion, resetFormInscripcion] = useForm({
        idpersona: '',
        idevento: idevento,
        idpersonaentidad: '',
        idcondicionpago: '',
        ideventotarifa: '',
        observaciones: '',
        nombre_completo: '',
        abona: 'P',
        comunicar: [],
        facturar: [],
    })

    // -------------------- GET Inscripcion

    const [fetchInscripcionGET, fetchInscripcionGETData] = InscripcionServices.GET()

    useEffect(() => {

        if (isStatusSucess(fetchInscripcionGETData.status)) {

            handleFormInscripcion({
                ...fetchInscripcionGETData.data,
            })
        }
    }, [fetchInscripcionGETData])


    // -------------------- PATCH Persona Entidad

    const [fetchPersonaEntidadPATCH, fetchPersonaEntidadPATCHData] = InscripcionServices.PATCH(showModal_Alquiler.payload?.id)

    const handleSubmitEditar = () => {
        
        const isGratuitoTemp = isGratuito === 'true'

        if (isGratuitoTemp || (!isGratuitoTemp && handleValidationStep2(formInscripcion))) {
            fetchPersonaEntidadPATCH({
                body: {
                    ...formInscripcion,
                }
            })
        }

    }

    useEffect(() => {

        if (isStatusSucess(fetchPersonaEntidadPATCHData.status)) {

            fetchAlquileresGET({
                params: {
                    ...urlParams
                }
            })
            handleCloseModal_Alquiler()

        }
    }, [fetchPersonaEntidadPATCHData])

    // ---------- DELETE Persona Entidad

    const [fetchPersonaEntidadDELETE, fetchPersonaEntidadDELETEData] = InscripcionServices.DELETE(showModal_Alquiler.payload?.id)

    useEffect(() => {

        if (isStatusSucess(fetchPersonaEntidadDELETEData.status)) {
            fetchAlquileresGET({
                params: {
                    ...urlParams
                }
            })
            handleCloseModal_Alquiler()
        }
    }, [fetchPersonaEntidadDELETEData])

    const handleSubmitDELETE = () => {

        fetchPersonaEntidadDELETE()
    }

    // Acciones al Mostrar / Ocultar la Modal

    useEffect(() => {

        if (showModal_Alquiler.value) {

            if (showModal_Alquiler.payload?.id) {
                // fetchInscripcionGET({
                //     id: showModal_Alquiler.payload?.id
                // })
            }

        } else {

            resetFormInscripcion()
        }

    }, [showModal_Alquiler.value])


    const [valuesValidationPersona, handleValidationPersona, handleResetValidationPersona] = useValidator({
        idpersona: { isOk: true, msgError: [`La persona es obligatoria.`] },
    })

    const [valuesValidationEntidad, handleValidationEntidad, handleResetValidationEntidad] = useValidator({
        idpersonaentidad: { isOk: true, msgError: [`La entidad es obligatoria.`] },
    })


    const [valuesValidationStep2, handleValidationStep2, handleResetValidationStep2] = useValidator({
        idcondicionpago: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
        ideventotarifa: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })


    return (
        <>
            <Modal show={showModal_Alquiler.value} onHide={handleCloseModal_Alquiler} size='lg'>
                <Modal.Header className='border-bottom-0 py-4'>
                    <Modal.Title className='h5'>
                        {Lang('NUEVO_ALQUILER')}
                    </Modal.Title>
                    <button type="button" className="btn-close mx-0" aria-label="Close" onClick={handleCloseModal_Alquiler}></button>
                </Modal.Header>

                <WizardNuevoAlquiler
                    formInscripcion={formInscripcion}
                    handleFormInscripcion={handleFormInscripcion}
                    handleInputInscripcion={handleInputInscripcion}

                    formValuesSearch={formValuesSearch}
                    fetchAlquileresGET={fetchAlquileresGET}
                    handleCloseModal_Alquiler={handleCloseModal_Alquiler}
                    fetchPersonaEntidadPOST={fetchPersonaEntidadPOST}
                    fetchPersonaEntidadPOSTData={fetchPersonaEntidadPOSTData}
                />

            </Modal>



            <ModalStatusServer fetchData={fetchPersonaEntidadDELETEData} />

            <ModalStatusServer fetchData={fetchPersonaEntidadPATCHData} />

        </>
    )
}
